import {
  AUDIT_DETAIL_LOADED,
  AUDIT_FACETS_LOADED,
  AUDIT_FEED_APPENDED,
  AUDIT_FEED_LOADED,
  AUDIT_FEED_RESET,
  AUDIT_FILTERS_SET,
  AUDIT_LOADING,
} from "../../constants/ActionTypes";
import moment from "moment-timezone";

const INIT_STATE = {
  filters: {
    from: moment().tz("Africa/Johannesburg").subtract(2, "months").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    to:   moment().tz("Africa/Johannesburg").format("YYYY-MM-DD HH:mm:ss"),
    subject_type: [],
    event:        undefined,
    causer_type:  undefined,
    causer_id:    [],
    q:            undefined,
  },
  list: {
    data:        [],
    next_cursor: null,
    loading:     false,
  },
  detail: {
    item:    null,
    loading: false,
  },
  facets: {
    entity_types: [],
    event_types:  [],
    causer_kinds: [],
    loaded:       false,
  },
};

const auditReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AUDIT_FILTERS_SET:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case AUDIT_LOADING:
      return { ...state, list: { ...state.list, loading: !!action.payload } };

    case AUDIT_FEED_RESET:
      return { ...state, list: { ...INIT_STATE.list } };

    case AUDIT_FEED_LOADED:
      return {
        ...state,
        list: {
          data:        action.payload.data || [],
          next_cursor: action.payload.next_cursor || null,
          loading:     false,
        },
      };

    case AUDIT_FEED_APPENDED:
      return {
        ...state,
        list: {
          data:        [...state.list.data, ...(action.payload.data || [])],
          next_cursor: action.payload.next_cursor || null,
          loading:     false,
        },
      };

    case AUDIT_DETAIL_LOADED:
      return { ...state, detail: { item: action.payload, loading: false } };

    case AUDIT_FACETS_LOADED:
      return {
        ...state,
        facets: {
          entity_types: action.payload.entity_types || [],
          event_types:  action.payload.event_types  || [],
          causer_kinds: action.payload.causer_kinds || [],
          loaded:       true,
        },
      };

    default:
      return state;
  }
};

export default auditReducer;
